import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { TUniversalCard } from '../../types/universal-card';
import type { Project } from '../../types/project';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export const UniversalCard = ({
  data,
  index,
  project,
}: {
  data?: TUniversalCard;
  index: number;
  project?: Project;
}) => {
  return (
    <>
      {data && (
        <div key={index} className={cn('', 'ea-universal-card')}>
          <div className={cn('', 'ea-universal-card__image')}>
            <Image
              src={data.image.url}
              alt={resolveImageAlt(data?.image, data?.name)}
              fill
              sizes="(min-width: 768px) 50vw, 100vw"
              style={{ objectFit: 'cover', objectPosition: 'center' }}
            />
          </div>
          <div className={cn('', 'ea-universal-card__banner')}>
            <h3>{data.name}</h3>
            {data.description && (
              <HtmlRendererRaw
                className={cn('', 'ea-universal-card__description')}
                html={data.description}
              />
            )}
          </div>
        </div>
      )}
      {project && (
        <div key={index} className={cn('', 'ea-universal-card')}>
          <div className={cn('', 'ea-universal-card__image')}>
            <Image
              src={project?.image?.url || '/images/placeholder.png'}
              alt={resolveImageAlt(project?.image, project?.name)}
              fill
              sizes="(min-width: 768px) 50vw, 100vw"
              style={{ objectFit: 'cover', objectPosition: 'center' }}
            />
          </div>
          <div className={cn('', 'ea-universal-card__banner')}>
            <h3>{project?.name}</h3>
            <p className="text-sm text-[#868484] sm:text-base">
              cena na kľúč: {project.turnkey_price},- EUR s DPH!
            </p>
          </div>
        </div>
      )}
    </>
  );
};
